if (!customElements.get('gym-builder')) {
  customElements.define(
    'gym-builder',
    class GymBuilder extends HTMLElement {
      connectedCallback() {
        this.submitButton = this.querySelector('[data-gym-submit]');
        this.totalElement = this.querySelector('[data-gym-total]');

        this.addEventListener('change', this.recalc.bind(this));
        this.addEventListener('input', (event) => {
          if (event.target.matches('[data-gym-qty]')) this.recalc();
        });
        this.addEventListener('click', this.onCardClick.bind(this));
        this.submitButton?.addEventListener('click', this.onSubmit.bind(this));

        this.recalc();
      }

      get items() {
        return Array.from(this.querySelectorAll('[data-gym-item]'));
      }

      onCardClick(event) {
        const item = event.target.closest('[data-gym-item]');
        if (!item) return;
        if (event.target.closest('a, select, input, button, label')) return;

        const checkbox = item.querySelector('[data-gym-include]');
        if (!checkbox || checkbox.disabled) return;

        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }

      get cartDrawer() {
        return document.querySelector('cart-drawer');
      }

      itemData(item) {
        const include = item.querySelector('[data-gym-include]')?.checked ?? false;
        const select = item.querySelector('[data-gym-variant]');
        const hidden = item.querySelector('[data-gym-variant-hidden]');
        let id = null;
        let price = 0;

        if (select && select.selectedIndex >= 0) {
          const option = select.options[select.selectedIndex];
          id = select.value;
          price = parseInt(option?.dataset.price, 10) || 0;
        } else if (hidden) {
          id = hidden.value;
          price = parseInt(hidden.dataset.price, 10) || 0;
        }

        const quantityInput = item.querySelector('[data-gym-qty]');
        const quantity = Math.max(1, parseInt(quantityInput?.value, 10) || 1);

        return { include, id, price, quantity };
      }

      money(cents) {
        const format = theme.settings.currencyCodeEnabled ? theme.settings.moneyWithCurrencyFormat : theme.settings.moneyFormat;
        return theme.Currency.formatMoney(cents, format);
      }

      recalc() {
        let total = 0;
        let selected = 0;

        this.items.forEach((item) => {
          const data = this.itemData(item);
          const priceElement = item.querySelector('[data-gym-item-price]');
          if (priceElement) priceElement.textContent = this.money(data.price);

          item.classList.toggle('is-selected', data.include);

          if (data.include && data.id) {
            total += data.price * data.quantity;
            selected += 1;
          }
        });

        if (this.totalElement) {
          this.totalElement.textContent = total > 0 ? this.money(total) : '';
        }
        this.submitButton?.toggleAttribute('aria-disabled', selected === 0);
      }

      handleErrorMessage(message = false) {
        this.errorMessage = this.errorMessage || this.querySelector('.product-form__error-message');
        if (!this.errorMessage) return;
        this.errorMessage.toggleAttribute('hidden', !message);
        this.errorMessage.textContent = message || '';
      }

      onSubmit(event) {
        const items = this.items
          .map((item) => this.itemData(item))
          .filter((data) => data.include && data.id)
          .map((data) => ({ id: data.id, quantity: data.quantity }));

        if (!items.length) return;

        const payload = { items };

        if (document.body.classList.contains('template-cart') || theme.settings.cartType === 'page') {
          theme.utils.postLink2(theme.routes.cart_add_url, { parameters: { ...payload } });
          return;
        }

        event.preventDefault();
        if (this.submitButton.hasAttribute('aria-disabled')) return;
        this.activeElement = event.currentTarget;
        this.handleErrorMessage();

        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({ ...payload, sections: sectionsToBundle, sections_url: window.location.pathname });

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.setAttribute('aria-busy', 'true');

        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.handleErrorMessage(parsedState.description);
              document.dispatchEvent(new CustomEvent('ajaxProduct:error', { detail: { errorMessage: parsedState.description } }));
              return;
            }

            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
            cartJson['sections'] = parsedState['sections'];

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gym-builder', cart: cartJson });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));

            this.cartDrawer?.show(this.activeElement);
          })
          .catch((error) => console.log(error))
          .finally(() => {
            this.submitButton.removeAttribute('aria-busy');
            this.submitButton.removeAttribute('aria-disabled');
            this.recalc();
          });
      }
    }
  );
}
